<template>
  <div>
    <HeroBanner :page="'home'"/>
    <div class="container">
      <div class="columns">
        <div class="column is-four-fifths">
          <PostList/>
        </div>
        <div class="column">
          <EventList/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
import PostList from '@/components/PostList'
import EventList from '@/components/EventList'
export default {
  components: {
    HeroBanner,
    PostList,
    EventList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageHome.vue